import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleSortArrows = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M14.5 9.5L12 7L9.5 9.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14.5 14.5L12 17L9.5 14.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCircleSortArrows.js.map